// Lista vazia com convite claro para criar a primeira tarefa (US-006).
import { useTranslation } from 'react-i18next';
import { BeeLogo } from './Icon';

export function EmptyState() {
  const { t } = useTranslation();
  return (
    <div className="empty" data-testid="empty-state">
      <div className="empty__bee">
        <BeeLogo size={104} />
      </div>
      <h2 className="empty__title">{t('empty.title')}</h2>
      <p className="empty__body">{t('empty.body')}</p>
      <p className="empty__tip">{t('empty.tip')}</p>
    </div>
  );
}
